import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BaseInitialState, StateStatus } from '../extension-store/interfaces/extension-store.interfaces';

export interface AlarmState {
  lastUpdated: number;
}

export interface InitialAlarmState extends BaseInitialState {
  alarmState: AlarmState;
}

const initialState: InitialAlarmState = {
  status: StateStatus.IDLE,
  error: null,
  alarmState: {
    lastUpdated: Date.now(),
  },
};

export const AlarmStatus = createSlice({
  name: 'AppAlarmReducer',
  initialState,
  reducers: {
    setLastUpated: (mutableState, action: PayloadAction<number>) => {
      mutableState.alarmState.lastUpdated = action.payload;
    },
  },
});

export const { setLastUpated } = AlarmStatus.actions;
export const lastUpdated = (state: InitialAlarmState) => state.alarmState.lastUpdated;
